import React, { useState, useCallback, useRef } from 'react'
import styled from 'styled-components'
import { IconCaretDown } from '@loadsmart/icons'

import ExcelLogo from 'assets/icons/excel-logo.svg'
import UnstyledLink from 'components/UnstyledLink'
import { UnstyledButton } from 'components/Button'
import { baseURL } from 'utils/httpClient'
import { useModal } from 'hooks/useModal'
import { useOnClickOutside } from 'hooks/useOnClickOutside'

import UploadDialog from './UploadDialog'

const Container = styled.div`
  position: relative;
`
const Button = styled(UnstyledButton)`
  height: 100%;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  box-shadow: ${({ theme }) => theme.shadows.standard};
  display: flex;
  justify-content: space-around;
  padding: 15px 20px;

  > :first-child {
    margin-right: 10px;
  }
`
const MenuList = styled.ul`
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #979797;
  box-shadow: ${({ theme }) => theme.shadows.standard};
  width: max-content;
  right: 0;
`
const MenuItem = styled.li`
  padding: 15px 20px;
  font-size: 14px;
  :hover {
    background: ${({ theme }) => theme.colors.light};
  }

  ${UnstyledButton} {
    font-size: 14px;
    font-weight: 500;
  }

  ${UnstyledButton}, ${UnstyledLink} {
    margin: 0;
    padding: 0;
    text-align: left;
    width: 100%;
  }
`

export default function RFPFileActions({
  linkUUID,
  canReceiveProposals,
}: {
  linkUUID: string
  canReceiveProposals: boolean
}) {
  const ref = useRef(null)
  const [isOpen, setOpen] = useState(false)
  const { modalState, closeModal, openModal } = useModal()
  const toggleMenu = useCallback(() => {
    setOpen(!isOpen)
  }, [isOpen])
  const closeMenu = useCallback(() => setOpen(false), [])
  const downloadURL = new URL(
    `/api/proposals/${linkUUID}/download/`,
    baseURL
  ).toString()

  useOnClickOutside(ref, closeMenu)

  return (
    <>
      <Container ref={ref}>
        <Button onClick={toggleMenu} data-testid="button">
          <img src={ExcelLogo} alt="Excel logo" />
          <IconCaretDown width={14} />
        </Button>
        {isOpen && (
          <MenuList data-testid="menu">
            <MenuItem>
              <UnstyledLink href={downloadURL}>Download CSV</UnstyledLink>
            </MenuItem>
            {canReceiveProposals && (
              <MenuItem>
                <UnstyledButton onClick={openModal}>
                  Upload prices
                </UnstyledButton>
              </MenuItem>
            )}
          </MenuList>
        )}
      </Container>
      <UploadDialog
        downloadURL={downloadURL}
        isOpen={modalState}
        closeModal={closeModal}
        linkUUID={linkUUID}
      />
    </>
  )
}
